module.exports = __webpack_public_path__ + "static/img/08.e5f492d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/08.jpg
// module id = JneU
// module chunks = 0